module.exports = __webpack_public_path__ + "img/icon-41.9b7446f9.png";